<template>
  <div
    :class="{ 'drop-area-active': draggedOverItemId === currentItemId }"
    :style="droppedItemId === currentItemId ? 'transition: none' : ''"
    class="drop-area flex justify-center items-center"
  >
    Drop to move here
  </div>
</template>

<script>
export default {
  props: {
    currentItemId: {
      type: String,
      default: null,
    },
    draggedOverItemId: {
      type: String,
      default: null,
    },
    droppedItemId: {
      type: String,
      default: null,
    },
  },
}
</script>

<style scoped>
.drop-area {
  visibility: hidden;
  height: 0;
}
.drop-area-active {
  visibility: visible;
  height: 5rem;
  border: 2px dashed #c3c3c3;
  border-radius: 3px;
  background: #f1f1f1;
  cursor: grabbing;
  transition: height 0.2s ease-out;
}
</style>
